import { ContainerModule } from "inversify";
import * as Api from "@/app/interaction/api";
import BlockFileComponent from "./block-file-component.vue";
import { IncludeBlockFilesHandler } from './include-block-files-handler';

export const blockFileFactoryModule = new ContainerModule(bind => {
  bind<Api.InteractiveComponentPlugin>(Api.InteractiveComponentPluginSymbol)
    .toConstantValue(BlockFileComponent)
    .whenTargetNamed("block-file");

  bind<Api.IncludeComponentsHandlerInterface>(Api.IncludeComponentsHandlerSymbol).to(IncludeBlockFilesHandler);
});
